import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Modal from 'react-bootstrap/Modal';
import mapsIcon  from '../../img/mapsIcon.png'
import Maps from '../../../utils/Maps';
import { useTranslation } from 'react-i18next';
const ModalViewLocation = ({logo, address }) => {
    const { t } = useTranslation();
    const [modalviewLocation, setModalViewLocation] = useState(false);




    return (
        <>
        <div>
            

        </div>


            <Badge bg="dark" className='w-100 p-2 m-1' onClick={() => { setModalViewLocation(true) }}><img src={mapsIcon} alt="Ver Mapa" className='m-2' style={{ width: '50px', height: '50px', cursor: 'pointer' }} onClick={() => { setModalViewLocation(true) }} /> <br></br> {t('profile.modals.viewLocation.viewMap')} </Badge>
            <Modal
                centered
                className='bg-blur-sp'
                size="xl"
                show={modalviewLocation}
                onHide={() => setModalViewLocation(false)}
            >

                <Modal.Body className='bg-theme'>
                    <div className="d-flex justify-content-between">
                        <h2 className="text-theme h4">{t('profile.modals.viewLocation.title')}</h2>
                        <button
                            type="button" onClick={() => (setModalViewLocation(false))}
                            class="btn btn-light btn-circle shadow-sm"
                            data-bs-dismiss="modal"
                            aria-label={t('common.close')}
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <Maps modo="location" logo={logo} zoom={18} width={"100%"} height={"400px"} address={address} />
                    <div className='d-block mt-lg-1 mt-2'>
                        <div className='d-flex justify-content-end mt-2'>
                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                onClick={() => (setModalViewLocation(false))}
                            >
                                <i class="uil uil-times-circle"></i> {t('common.close')}
                            </button>
                        </div>
                    </div>
                </Modal.Body >
            </Modal >

        </>
    )
}

export default ModalViewLocation